import {
    FETCH_CROSS_SELL_AD_IMAGES,
    FETCH_CROSS_SELL_AD_IMAGES_FETCHING,
    FETCH_CROSS_SELL_AD_IMAGES_SUCCESS,
    FETCH_CROSS_SELL_AD_IMAGES_FAIL
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    crossSellAdImages: {},
    crossSellAdImagesFetching: false,
    crossSellAdImagesFetchFail: false
};

// ======= Fetching Handlers =======
const fetchCrossSellAdImagesFetching = (state) => {
    return {
        ...state,
        crossSellAdImagesFetching: true,
        crossSellAdImagesFetchFail: false
    };
};

const fetchCrossSellAdImagesSuccess = (state, action) => {
    return {
        ...state,
        crossSellAdImages: action.data,
        crossSellAdImagesFetching: false,
        crossSellAdImagesFetchFail: false
    };
};

const fetchCrossSellAdImagesFail = (state) => {
    return {
        ...state,
        crossSellAdImagesFetching: false,
        crossSellAdImagesFetchFail: true
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_CROSS_SELL_AD_IMAGES_FETCHING]: fetchCrossSellAdImagesFetching,
    [FETCH_CROSS_SELL_AD_IMAGES_SUCCESS]: fetchCrossSellAdImagesSuccess,
    [FETCH_CROSS_SELL_AD_IMAGES_FAIL]: fetchCrossSellAdImagesFail
};

// ======= Default Action ======
export default function imagePaths(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchCrossSellAdImages(evictCache) {
    return {
        type: FETCH_CROSS_SELL_AD_IMAGES,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

// ======= Selectors =======
export const getCrossSellAdImages = (state) => {
    return state.imagePaths.crossSellAdImages ? state.imagePaths.crossSellAdImages : null;
};

export const isCrossSellAdImagesFetching = (state) => {
    return state.imagePaths.crossSellAdImagesFetching;
};

export const didCrossSellAdImagesFetchFail = (state) => {
    return state.imagePaths.crossSellAdImagesFetchFail;
};
